
import { ChangeEvent, FC, memo } from 'react';
import styled from 'styled-components';
import { Select } from '@keaze/web/components/select';
import { SortOptions } from '@keaze/web/common/interfaces';
import { Skeleton } from './sortBy.styled';


const S = {
  sortByTitle: styled.h4`
  ${({ theme: { breakpoints } }) => `
  ${breakpoints.up('md')} { display: block}
  margin-right: 20px;
  fot-size: 18px;
  display: none;
`}
  `,


  selectBox: styled(Select)`
  ${({ theme: { colors, breakpoints} }) => `
  // .MuiSelect-iconOpen	{border:1px solid red !important;}
   > div {border-radius: 3px !important}
    padding: 0;
    border-radius: 0 !important;
    margin-right:0px;


    ${breakpoints.up('md')} {  width: 230px !important;    margin-right:28px;}
    width: 130px !important;

    height:40px ;
    .MuiSelect-select {
      padding: 5px 30px 5px 10px !important;
      
         p {
          font-weight: bold !important;
          color: ${colors.greens.green0}
        }
          ${breakpoints.up('md')} { font-size: 16px;}
          font-size: 12px; 
        
    }
    
      font-size: 12px !important;

    }
    svg path {fill: ${colors.greens.green0} !important;}
    .MuiMenu-list {background-color: red;}
    .MuiPopover-paper {border:1px solid red;}
`}`



};

type Props = {
 
  value: string;
  options: SortOptions;
  
  onChange: (value: string) => void;
};

type OnSelectSortByChange = (
  args: ChangeEvent<{
    name?: string;
    value: unknown;
  }>
) => void;

type SelectData = {
  value: string;
  label: string;
  
};

type ConvertOptionsToData = (options: SortOptions) => SelectData[];

const convertOptionsToData: ConvertOptionsToData = (options) =>
  options.map(({ text, value }) => ({
    value,
    label: text,
  }));

export const SortBy: FC<Props> = memo(({ value, options, onChange, }) => {
  if (options.length === 0) {
    return <Skeleton variant="rect" />;
  }

  const handleChange: OnSelectSortByChange = ({ target: { value } }) => {
    onChange(value as string);
  };

  return (
    <>
        <S.sortByTitle>Sort order</S.sortByTitle>
    <S.selectBox
      fullWidth
      value={value}
      onChange={handleChange}
      data={convertOptionsToData(options)}
    />
    </>
  );
});
